import { CircularProgress, Box } from '@mui/material';
import { Dispatch, FC, SetStateAction, useCallback, useState } from 'react';

import { useGetCamerasListQuery } from '@api/connectInstance';
import { CameraInfo, RdConnectInstance } from '@apiContract';
import isUndefined from 'lodash/fp/isUndefined';

import { getCameraInfo } from '@src/api/automatedCapture';
import { useInterval } from '@hooks/useInterval';

import ChooseCameraButton from './ChooseCameraButton';
import sx from './styles';

type Props = {
  userDevice: RdConnectInstance;
  userCamera: CameraInfo;
  setUserCamera: Dispatch<SetStateAction<CameraInfo>>;
};

const DeviceCamera: FC<Props> = ({ userDevice, userCamera, setUserCamera }) => {
  const [image, setImage] = useState<string>('');
  const userDeviceId = userDevice?.id;
  const userCameraIndex = userCamera?.index;
  const { data } = useGetCamerasListQuery({ rdConnectInstanceId: userDeviceId });

  const fetchCameraImage = useCallback(async () => {
    if (isUndefined(userDeviceId) || isUndefined(userCameraIndex)) {
      return;
    }

    try {
      const response = await getCameraInfo({
        rdConnectInstanceId: userDeviceId,
        index: userCameraIndex,
      });

      setImage(`data:image/jpeg;base64,${response?.data?.objectData?.snapshotBase64}`);
    } catch (error) {
      console.error('Error fetching camera image:', error);
    }
  }, [userCameraIndex, userDeviceId]);

  useInterval(fetchCameraImage, 500);

  return (
    <Box sx={sx.container}>
      <ChooseCameraButton cameraIndex={userCamera?.index} cameras={data?.cameras} setUserCamera={setUserCamera} />

      {image ? <Box component="img" src={image} sx={sx.img} /> : <CircularProgress sx={sx.loader} />}
    </Box>
  );
};

export default DeviceCamera;
